<div [ngClass]="{'sidebar-container': true, 'small-sidebar': isToggle}" class="d-none d-lg-flex">
    <div class="sidebar bg-white rounded-3 shadow p-3" id="sidebar">
        <div class="logo-container">
            <img src="/assets/images/logo_color.png" alt="Logo" class="logo">
        </div>
        <ul class="nav flex-column">
            <li class="nav-item shepherd-dashboard">
                <a class="nav-link text-dark" [routerLink]="'/dashboard'" routerLinkActive="active-route"><i
                        class="fas fa-home"></i> <span class="link-text">{{"Dashboard" | translate}}</span></a>
            </li>
            <li class="nav-item shepherd-service">
                <a class="nav-link text-dark" [routerLink]="'/service'" routerLinkActive="active-route"><i
                        class="fas fa-barcode-read"></i> <span class="link-text">{{"Services" | translate}}</span></a>
            </li>
            <!-- <li class="nav-item shepherd-wallet">
                <a class="nav-link text-dark" [routerLink]="'/wallet'" routerLinkActive="active-route"><i class="fas fa-wallet"></i> <span class="link-text">{{"Wallet" | translate}}</span></a>
            </li> -->
            <li class="nav-item shepherd-project">
                <a class="nav-link text-dark" [routerLink]="'/project'" routerLinkActive="active-route"><i
                        class="fas fa-folder"></i> <span class="link-text">{{"Projects" | translate}}</span></a>
            </li>
            <li class="nav-item shepherd-contract">
                <a class="nav-link text-dark" [routerLink]="'/contract'" routerLinkActive="active-route">
                    <div class="nav-link-icon-container">
                        <i class="fas fa-file-contract relative"></i>
                        <div [ngClass]="{'count': true, 'count-toggle': isToggle}" *ngIf="contractRequestCount > 0">
                            {{contractRequestCount<10 ? contractRequestCount : '9+' }}</div>
                        </div>
                        <span class="link-text">{{"Contracts" | translate}}</span>
                </a>
            </li>

            <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/products'" routerLinkActive="active-route" > 
                    <i class="fas fa-box-open"></i>
                    <span class="link-text">{{ "Products" | translate }}</span>
                </a>
            </li>

            <li class="nav-item shepherd-discount">
                <a class="nav-link text-dark" [routerLink]="'/discount'" routerLinkActive="active-route">
                    <i class="fas fa-tags"></i>
                    <span class="link-text">{{"Discounts" | translate}}</span>
                </a>
            </li>
            <li class="nav-item shepherd-user" *ngIf="role === 1">
                <a class="nav-link text-dark" [routerLink]="'/user'" routerLinkActive="active-route">
                    <div class="nav-link-icon-container">
                        <i class="fas fa-users relative"></i>
                        <div [ngClass]="{'count': true, 'count-toggle': isToggle}" *ngIf="unverifiedCustomer > 0">
                            {{unverifiedCustomer<10 ? unverifiedCustomer : '9+' }}</div>
                        </div>
                        <span class="link-text">{{"Customer Management" | translate}}</span>
                </a>
            </li>
            <li class="nav-item shepherd-price" *ngIf="role === 1">
                <a class="nav-link text-dark" [routerLink]="'/price'" routerLinkActive="active-route"><i
                        class="fas fa-euro-sign"></i> <span class="link-text">{{"Prices" | translate}}</span></a>
            </li>
            <li class="nav-item shepherd-primer" *ngIf="role === 1">

                <a class="nav-link text-dark" [routerLink]="'/primer'" routerLinkActive="active-route">
                    <div class="nav-link-icon-container">
                        <i class="fas fa-file-contract relative"></i>
                        <div [ngClass]="{'count': true, 'count-toggle': isToggle}" *ngIf="unverifiedPrimer > 0">
                            {{unverifiedPrimer<10 ? unverifiedPrimer : '9+' }}</div>
                        </div>
                        <span class="link-text">{{"Primer" | translate}}</span>
                </a>
            </li>

            <li class="nav-item shepherd-invoices" *ngIf="role === 1">
                <a class="nav-link text-dark" [routerLink]="'/invoices'" routerLinkActive="active-route">
                    <i class="fas fa-file-invoice"></i>
                    <span class="link-text">{{"Invoices" | translate}}</span>
                </a>
            </li>

            <li class="nav-item">
                <a class="nav-link text-dark" (click)="startSidebarTour()"><i class="fas fa-question-circle"></i> <span
                        class="link-text">{{"Guide Me" | translate}}</span></a>
            </li>
        </ul>
        <div class="sidebar-footer">
            <a href="https://www.metabarcoding.com/imprint" target="_blank" class="sidebar-footer-link"
                [ngClass]="{ 'hide-text': isToggle }">
                {{ 'Imprint' | translate }}
            </a>

            <a href="https://www.metabarcoding.com/privacy" target="_blank" class="sidebar-footer-link"
                [ngClass]="{ 'hide-text': isToggle }">
                {{ 'Privacy Policy' | translate }}
            </a>
        </div>

    </div>
</div>


<div class="sidebar-container-small d-lg-none" [ngClass]="{'sidebar-open': isOpen, 'sidebar-close': !isOpen}">
    <nav class="sidebar-content">
        <div class="logo-container">
            <img src="/assets/images/logo_color.png" alt="Logo" class="logo">
        </div>
        <ul class="nav flex-column">
            <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/dashboard'" (click)="navigate('/dashboard')"><i
                        class="fa-solid fa-home"></i> {{"Dashboard" | translate}}</a>
            </li>
            <li class="nav-item" *ngIf="role === 1">
                <a class="nav-link text-dark" [routerLink]="'/user'" (click)="navigate('/user')">
                    <div class="nav-link-icon-small-container">
                        <i class="fa-solid fa-users relative"></i>
                        <div [ngClass]="{'count': true}" *ngIf="unverifiedCustomer > 0">{{unverifiedCustomer<10 ?
                                unverifiedCustomer : '9+' }}</div>
                        </div>
                        <span class="link-text">{{"Customer Management" | translate}}</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/user'" (click)="navigate('/service')"><i
                        class="fa-solid fa-barcode-read"></i> {{"Services" | translate}}</a>
            </li>
            <li class="nav-item" *ngIf="role === 1">
                <a class="nav-link text-dark" [routerLink]="'/price'" (click)="navigate('/price')"><i
                        class="fa-solid fa-euro-sign"></i> {{"Price" | translate}}</a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/project'" (click)="navigate('/project')"><i
                        class="fa-solid fa-folder"></i> <span class="link-text">{{"Project" | translate}}</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/primer'" (click)="navigate('/primer')">
                    <div class="nav-link-icon-small-container">
                        <i class="fa-solid fa-tags relative"></i>
                        <div [ngClass]="{'count': true}" *ngIf="unverifiedPrimer > 0">{{unverifiedPrimer<10 ?
                                unverifiedPrimer : '9+' }}</div>
                        </div>
                        <span class="link-text">{{"Primer" | translate}}</span>
                </a>
            </li>


           <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/products'" (click)="navigate('/products')">
                    <i class="fa-solid fa-box-open"></i>
                    {{ "Products" | translate }}
                </a>
            </li>


            <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/discount'" (click)="navigate('/discounts')">
                    <i class="fa-solid fa-tags"></i>
                    {{"Discounts" | translate}}
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/contract'" (click)="navigate('/contract')">
                    <div class="nav-link-icon-small-container">
                        <i class="fa-solid fa-file-contract relative"></i>
                        <div [ngClass]="{'count ': true}" *ngIf="contractRequestCount > 0">{{contractRequestCount<10 ?
                                contractRequestCount : '9+' }}</div>
                        </div>
                        <span class="link-text">{{"Contract" | translate}}</span>
                </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link text-dark" [routerLink]="'/wallet'" (click)="navigate('/wallet')"><i class="fa-solid fa-wallet"></i> <span class="link-text">{{"Wallet" | translate}}</span></a>
            </li> -->
            <li class="nav-item" *ngIf="role === 1">
                <a class="nav-link text-dark" [routerLink]="'/invoices'" (click)="navigate('/invoices')">
                    <i class="fa-solid fa-file-invoice"></i>
                    {{"Invoices" | translate}}
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-dark" (click)="close()"><i class="fa-solid fa-xmark"></i> {{"Close" |
                    translate}}</a>
            </li>
        </ul>
    </nav>
</div>